class DTMFToneGenerator {
    constructor() {
        this.context = null;
        this.oscillator1 = null;
        this.oscillator2 = null;
        this.gainNode1 = null;
        this.gainNode2 = null;
        this.isPlaying = false;
        
        // DTMF frekans tablosu
        this.frequencies = {
            '1': [697.0, 1209.0],
            '2': [697.0, 1336.0],
            '3': [697.0, 1477.0],
            '4': [770.0, 1209.0],
            '5': [770.0, 1336.0],
            '6': [770.0, 1477.0],
            '7': [852.0, 1209.0],
            '8': [852.0, 1336.0],
            '9': [852.0, 1477.0],
            '*': [941.0, 1209.0],
            '0': [941.0, 1336.0],
            '#': [941.0, 1477.0]
        };
        
        this.initAudioContext();
    }
    
    initAudioContext() {
        const contextClass = (window.AudioContext ||
            window.webkitAudioContext ||
            window.mozAudioContext ||
            window.oAudioContext ||
            window.msAudioContext);
            
        if (contextClass) {
            this.context = new contextClass();
        } else {
            console.warn('Web Audio API is not supported');
        }
    }
    
    playTone(digit, duration = 200) {
        if (!this.context || !this.frequencies[digit]) {
            console.warn('Invalid digit or no audio context:', digit);
            return;
        }
        
        // Önceki sesi durdur
        this.stop();
        
        const [freq1, freq2] = this.frequencies[digit];
        
        try {
            // İlk osilatör
            this.oscillator1 = this.context.createOscillator();
            this.oscillator1.type = 'sine';
            this.oscillator1.frequency.value = freq1;
            
            this.gainNode1 = this.context.createGain ? this.context.createGain() : this.context.createGainNode();
            this.oscillator1.connect(this.gainNode1);
            this.gainNode1.connect(this.context.destination);
            this.gainNode1.gain.value = 0.1;
            
            // İkinci osilatör
            this.oscillator2 = this.context.createOscillator();
            this.oscillator2.type = 'sine';
            this.oscillator2.frequency.value = freq2;
            
            this.gainNode2 = this.context.createGain ? this.context.createGain() : this.context.createGainNode();
            this.oscillator2.connect(this.gainNode2);
            this.gainNode2.connect(this.context.destination);
            this.gainNode2.gain.value = 0.1;
            
            // Osilatörleri başlat
            this.oscillator1.start ? this.oscillator1.start(0) : this.oscillator1.noteOn(0);
            this.oscillator2.start ? this.oscillator2.start(0) : this.oscillator2.noteOn(0);
            
            this.isPlaying = true;
            
            // Belirtilen süre sonra durdur
            setTimeout(() => {
                this.stop();
            }, duration);
            
        } catch (error) {
            console.error('DTMF tone generation error:', error);
        }
    }
    
    stop() {
        try {
            if (this.oscillator1) {
                this.oscillator1.disconnect();
                this.oscillator1 = null;
            }
            if (this.oscillator2) {
                this.oscillator2.disconnect();
                this.oscillator2 = null;
            }
            if (this.gainNode1) {
                this.gainNode1.disconnect();
                this.gainNode1 = null;
            }
            if (this.gainNode2) {
                this.gainNode2.disconnect();
                this.gainNode2 = null;
            }
            this.isPlaying = false;
        } catch (error) {
            console.error('DTMF stop error:', error);
        }
    }
}

// Singleton instance
const dtmfGenerator = new DTMFToneGenerator();

export default dtmfGenerator; 